import axios from '@/api/axios'

const getSportObjects = () => {
  return axios.get(`/sportsObjects`)
}

const getSportSearchObjects = (params) => {
  return axios.get(`/sportsObjectsList`, {params})
}

const addSportObjects = (objects) => {
  return axios.post(`/sportsObjects`, objects)
}

const updateSportObjects = (object) => {
  return axios.put(`/sportsObjects/${object.id}`, object)
}

const getSportObject = (id) => {
  return axios.get(`/sportsObjects/${id}`)
}

const deleteSportObject = (id) => {
  return axios.delete(`/sportsObjects/${id}`)
}

const getSportObjectsList = (params) => {
  return axios.get(`/sportsObjectsListForAdmin`, {params})
}

export default {
  getSportObjects,
  addSportObjects,
  getSportObject,
  updateSportObjects,
  deleteSportObject,
  getSportObjectsList,
  getSportSearchObjects,
}
